<!--suppress ALL -->
<script lang="ts">
import {statusProseses} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class ProsesSelect extends Vue {

    @Prop({default: statusProseses[0], type: String})
    public proses: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectProses(param: any) {
      this.$emit('update:proses', param || statusProseses[0]);
      this.$emit('selected', param);
    }

    public render(createElement: Function) {
      const {$t, proses, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: proses,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.proses')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectProses}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(statusProseses).map((item: any) => {
        const option: any = {attrs: {value: item}};

        return createElement('option', option, item.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.proses'), message, type}}, [main]);
    }
  }
</script>
